
import * as React from 'react';
import { fluentSvgIconStyles } from '../../../../styles/iconStyles';

export const Send20Regular: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return <svg role="img" focusable="false" aria-hidden viewBox="0 0 20 20" width={20} height={20} fill="currentColor" className={props.className} style={{ ...props.style, ...fluentSvgIconStyles }} onClick={props.onClick}>
        <path
            d="M2.18 2.11a.5.5 0 0 1 .54-.06l15 7.5a.5.5 0 0 1 0 .9l-15 7.5a.5.5 0 0 1-.7-.58L3.98 10 2.02 2.63a.5.5 0 0 1 .16-.52Zm2.7 8.39-1.61 6.06L16.38 10 3.27 3.44 4.88 9.5h6.62a.5.5 0 1 1 0 1H4.88Z"
            fill="currentColor"
        />
    </svg>
}